import React from 'react';
import styled from 'styled-components';
import { Link } from 'components/Common';
import { connect } from 'react-redux';

import { RoutePaths } from '../../constants';
import { BackLink } from './Navigation/BackLink';
import { fontSemibold } from '../../themes';
import i18n from '../../i18n';
import { SearchButton } from './SearchButton';
import { navigateOut } from '../../utils';
import ModalSwitcher from './ModalSwitcher/index';

import { TOP_BAR_DEVICE_RENAME } from 'config';

const DEVICE_RENAME: any = TOP_BAR_DEVICE_RENAME;

const HomeDiv = styled('div')<{ backgroundColor?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 10px;
  background-color: ${({ backgroundColor = '#ffffff'} ) => backgroundColor};
`;

const lightGrey = '#E7E9EA';

const CenterLinksContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  background-color: ${lightGrey};
  border-radius: 15px;
  padding: 2px;
`;

const CenterTitleContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 8px;
  font-family: ${fontSemibold};
`;

const BackDiv = styled.div`
  padding: 6px;
`;

const SearchDiv = styled.div`
  padding: 5px 10px;
  margin-right: -20px;
  width: 41px;
`;

const CenterItem = styled('div')<{ selected?: boolean }>`
  padding: 5px 7px;
  background-color: ${props => props.selected ? 'white' : lightGrey};
  color: ${props => props.selected ? '#122530' : '#9BA1A5'};
  border-radius: 15px;
`;

const CenterLink = styled(Link)`
  font-family: ${fontSemibold};
  white-space: nowrap;
`;

const mapStateToProps = (state: any) => {
  const {
    features: { flags },
    currentUser
  } = state.registry;

  let deviceName = currentUser?.device?.productName;
  if (deviceName && DEVICE_RENAME[deviceName]) {
    deviceName = DEVICE_RENAME[deviceName];
  }

  return {
    showSearch: flags.showSearch,
    enableTiles: flags.enable_tiles,
    deviceName
  };
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface HomeContainerProps extends ReduxProps {
  selected?: RoutePaths;
  centerTitle?: string;
  showTitle?: boolean;
  headerColor?: string;
}

class HomeContainer extends React.Component<HomeContainerProps, any> {

  render() {
    const { showSearch, headerColor, selected } = this.props;
    let goBack;
    if (selected) {
      goBack = () => {
        navigateOut();
      }
    }

    return (
      <div>
        <ModalSwitcher />
        <HomeDiv backgroundColor={headerColor}>
          <BackDiv>
            <BackLink backNavigate={goBack} />
          </BackDiv>
          <div>
            {this.renderCenterContent()}
          </div>
          <SearchDiv>
            {showSearch && <SearchButton />}
          </SearchDiv>
        </HomeDiv>
        <div>
          {this.props.children}
        </div>
      </div>
    )
  }

  private renderCenterContent() {
    const { centerTitle, showTitle } = this.props;
    if (showTitle) {
      return <CenterTitleContainer>{centerTitle}</CenterTitleContainer>
    } else {
      return (
        <CenterLinksContainer>
          {this.renderCenterLinks()}
        </CenterLinksContainer>
      );
    }
  }

  private renderCenterLinks() {
    const { selected, deviceName, enableTiles } = this.props;
    const deviceText = i18n('page.Home.device')();
    const clocksText = i18n('page.Home.clocks')();
    const appsText = i18n('page.Home.apps')();
    const tilesText = i18n('page.Home.tiles')();

    const links = [
      {
        to: '/v2/device',
        label: deviceText,
        id: 'mine-top-link',
      },
      {
        to: '/v2/clocks/gallery',
        label: clocksText,
        id: 'clocks-top-link',
      },
      {
        to: '/v2/apps/gallery',
        label: appsText,
        id: 'apps-top-link',
      },
    ];

    if (enableTiles) {
      links.push({
        to: '/v2/tiles/gallery',
        label: tilesText,
        id: 'tiles-top-link',
      })
    }

    return links.map(({ to, label, id }) => {
      const text = to === '/v2/device' ? deviceName || label : label;

      return (
        <CenterItem key={id} selected={selected === to}>
          <CenterLink aria-label={id} id={id} to={to}>{text}</CenterLink>
        </CenterItem>
      );
    });
  }

}

export default connect(mapStateToProps)(HomeContainer);
